// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import hotelReducer from './hotel/hotelListSlice';
import HotelsResultFilterSlice from './hotel/HotelsResultFilterSlice';
import flightOneWaySlice from './flight/flightOneWaySlice';
import flightCountryListReducer from './flight/flightSearchListSlice';
import flightRoundCityFlightSlice from './flight/flightRoundCityFlightSlice';
import flightFilterReducer from './flight/flightFilterSlice';
import flightRoundTripFilter from './flight/flightRoundTripFilterSlice';
import flightOffersReducer from './flight/flightOffersSlice';
import hotelFilterSlice from './hotel/hotelFilterSlice';
import hotelsListSlice from './hotel/hotelsListSlice';
import flightReducer from './flight/flightSlice';
import cityReducer from './flight/citySlice'
import hotelOffersReducer from './flight/hotelOffersSlice';
import modalReducer from "./hotel/modalSlice"
import seoHotelCity from '../redux/seo/cityHotelSlice';

const store = configureStore({
  reducer: {
    hotel: hotelReducer,
    hotelFilter: HotelsResultFilterSlice,
    flightOneWay: flightOneWaySlice,
    flightList: flightCountryListReducer,
    flightRoundCity: flightRoundCityFlightSlice,
    flightFilter: flightFilterReducer,
    flightFilterRoundTrip: flightRoundTripFilter,
    flightOffers: flightOffersReducer,
    hotelFilter: hotelFilterSlice,
    hotelData: hotelsListSlice,
    flights: flightReducer,
    cities: cityReducer,
    hotelOffers: hotelOffersReducer,
    modal: modalReducer,
    seoHotelCity: seoHotelCity,
  },
});

export { store };
